// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuListLinkItem-module-item > a {
  margin: 0;
  padding: 15px;
  background-color: var(--secondary-button-background);
  color: inherit;
  display: flex;
  opacity: 0.7;
  transition: 0.1s;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}

.MenuListLinkItem-module-item > a:hover {
  opacity: 1;
}

.MenuListLinkItem-module-item > a > svg {
  width: 30px;
  height: 30px;
  fill: var(--text);
  flex-shrink: 0;
}

.MenuListLinkItem-module-item > a > section {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-direction: row;
}

.MenuListLinkItem-module-item > a > section > svg {
  width: 30px;
  height: 30px;
  fill: var(--text);
  flex-shrink: 0;
}

.MenuListLinkItem-module-information {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.MenuListLinkItem-module-information > span {
  color: var(--text-bold);
}

.MenuListLinkItem-module-information > p {
  font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/menu-list-items/MenuListLinkItem/MenuListLinkItem.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".item > a {\r\n  margin: 0;\r\n  padding: 15px;\r\n  background-color: var(--secondary-button-background);\r\n  color: inherit;\r\n  display: flex;\r\n  opacity: 0.7;\r\n  transition: 0.1s;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.item > a:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.item > a > svg {\r\n  width: 30px;\r\n  height: 30px;\r\n  fill: var(--text);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.item > a > section {\r\n  display: flex;\r\n  gap: 15px;\r\n  align-items: center;\r\n  flex-direction: row;\r\n}\r\n\r\n.item > a > section > svg {\r\n  width: 30px;\r\n  height: 30px;\r\n  fill: var(--text);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.information {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0;\r\n}\r\n\r\n.information > span {\r\n  color: var(--text-bold);\r\n}\r\n\r\n.information > p {\r\n  font-size: 0.9rem;\r\n}"],"sourceRoot":""}]);
// Exports
export var item = `MenuListLinkItem-module-item`;
export var information = `MenuListLinkItem-module-information`;
export default ___CSS_LOADER_EXPORT___;
